// extracted by mini-css-extract-plugin
export var menuIcon = "_qu-0";
export var menuIconInline = "_qu-1";